import { render, staticRenderFns } from "./Page14.vue?vue&type=template&id=65b70e4b&"
import script from "./Page14.vue?vue&type=script&lang=js&"
export * from "./Page14.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports